<template>
  <el-dialog
    append-to-body
    width="500px"
    :title="`用户: ${currentRow.name}`"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="left"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item label="会员有效期至:">
        {{ currentRow.vip_end_time || "非会员" }}
      </el-form-item>
      <el-form-item prop="days" label="赠送会员:">
        <el-input
          v-model="form.data.days"
          placeholder="请输入"
          clearable
          size="mini"
          @input="handlePositiveInteger"
        >
          <div slot="suffix">天</div>
        </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      currentRow: {},
      visible: false,
      form: {
        loading: false,
        data: {
          days: "",
        },
        rules: {
          days: [{ required: true, message: "请输入", trigger: "blur" }],
        },
      },
    };
  },
  methods: {
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.currentRow = row;
    },
    reset(done) {
      this.currentRow = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    handlePositiveInteger() {
      // 只保留数字
      let val = this.form.data.days.replace(/[^0-9]/g, "");

      // 转数字并判断是否大于0
      val = Number(val);
      if (isNaN(val) || val <= 0) {
        this.form.data.days = "";
      } else {
        this.form.data.days = val;
      }
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          return false;
        }
      });
    },
    submitForm() {
      this.$confirm(`确定赠送【${this.currentRow.name}】会员卡吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          this.$http
            .post("admin/user/issuedVip", {
              id: this.currentRow.id,
              days: this.form.data.days,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.$emit("refresh");
                this.toggle(false);
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>